import { render, staticRenderFns } from "./prescriptions.vue?vue&type=template&id=571097d6&scoped=true&"
import script from "./prescriptions.vue?vue&type=script&lang=js&"
export * from "./prescriptions.vue?vue&type=script&lang=js&"
import style0 from "./prescriptions.vue?vue&type=style&index=0&id=571097d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571097d6",
  null
  
)

export default component.exports